const studies = [
  {
    metric: 'Faster close',
    headline: 'Monthly close made usable again.',
    body: 'For a multi-entity e-commerce group, rebuilt close support around structured trackers, accrual models, reconciliation controls, and lender-reporting discipline. The result was a cleaner rhythm and fewer manual bottlenecks.',
    duration: 'Long-running engagement',
  },
  {
    metric: 'Finance + tooling',
    headline: 'Finance operations with builder leverage.',
    body: 'Operated as the de-facto one-person finance department: AP ownership, AR oversight, full close, expense management, vendor relationships. When the role needed to scale, I designed the systems instead of hiring more people.',
    duration: 'Anonymized prior work',
  },
];

export function CaseStudyStrip() {
  return (
    <section id="case-work" data-guide-label="Proof" className="border-b border-ink/5 bg-ink text-paper">
      <div className="mx-auto max-w-5xl px-6 py-24">
        <p className="font-display text-xs uppercase tracking-[0.25em] text-accent">
          Proof of work
        </p>
        <h2 className="mt-3 font-display text-3xl tracking-tight md:text-4xl">
          What I've shipped for prior clients.
        </h2>
        <p className="mt-3 max-w-2xl text-paper/70">
          Anonymized per prior-engagement terms. Specific enough to inspect,
          restrained enough to respect the client.
        </p>
        <div className="mt-12 grid gap-8 md:grid-cols-2">
          {studies.map((s) => (
            <article key={s.headline} className="border-l-2 border-accent pl-6">
              <p className="font-display text-4xl text-accent md:text-5xl">{s.metric}</p>
              <h3 className="mt-4 font-display text-xl leading-snug">{s.headline}</h3>
              <p className="mt-4 text-paper/70">{s.body}</p>
              <p className="mt-4 text-xs uppercase tracking-[0.2em] text-paper/40">
                {s.duration}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
